/*
 * ceq-lead-form.js
 * Submit-Handler fuer ceq-hero-form.liquid und ceq-lead-form.liquid.
 *
 * Features:
 * - Honeypot-Check (verworfene Submission bei ausgefuelltem "website"-Feld)
 * - Time-Trap (Submit muss mindestens MIN_FILL_TIME_MS nach Pageload erfolgen)
 * - UTM-Hidden-Fields werden aus window.location ausgelesen und befuellt
 * - Fetch-POST zur action-URL (n8n-Webhook), mit Loading/Success/Error-States
 * - Faked Success bei Bot-Verdacht (Bot lernt nicht dass er erkannt wurde)
 * - GA4 dataLayer-Event "generate_lead" bei echtem Erfolg
 *
 * Geladen via <script defer> in beiden Form-Sections.
 */
(function () {
  'use strict';

  var MIN_FILL_TIME_MS = 2000;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function init() {
    var forms = document.querySelectorAll('[data-ceq-lead-form]');
    if (!forms.length) return;
    forms.forEach(setupForm);
  }

  function setupForm(form) {
    if (form.dataset.ceqLeadFormReady === '1') return;
    form.dataset.ceqLeadFormReady = '1';

    var loadedAt = Date.now();
    // Time-Trap pro Formular konfigurierbar via data-min-fill-ms (Default 2000 ms).
    // Survey-Forms (1-2 Klicks) setzen einen niedrigen Wert, damit schnelle echte
    // Antworten nicht faelschlich als Bot gewertet werden (sonst fakeSuccess ohne POST).
    var minFill = parseInt(form.dataset.minFillMs, 10);
    if (isNaN(minFill)) minFill = MIN_FILL_TIME_MS;
    prefillHiddenFields(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (isHoneypotFilled(form)) {
        fakeSuccess(form);
        return;
      }

      if (Date.now() - loadedAt < minFill) {
        fakeSuccess(form);
        return;
      }

      submitForm(form);
    });
  }

  function isHoneypotFilled(form) {
    var hp = form.querySelector('input[name="website"]');
    return hp && hp.value.trim() !== '';
  }

  function prefillHiddenFields(form) {
    var params = new URLSearchParams(window.location.search);

    UTM_KEYS.forEach(function (key) {
      var input = form.querySelector('input[name="' + key + '"]');
      if (input) input.value = params.get(key) || '';
    });

    var refInput = form.querySelector('input[name="referrer"]');
    if (refInput) refInput.value = document.referrer || '';

    var pageUrlInput = form.querySelector('input[name="page_url"]');
    if (pageUrlInput) pageUrlInput.value = window.location.href;

    var loadedAtInput = form.querySelector('input[name="form_loaded_at"]');
    if (loadedAtInput) loadedAtInput.value = Date.now();
  }

  function submitForm(form) {
    var submitBtn = form.querySelector('[data-ceq-lead-form-submit]');
    var label = form.querySelector('.ceq-lead-form__submit-label');
    var loadingLabel = form.querySelector('.ceq-lead-form__submit-loading');
    var errorBox = form.parentElement
      ? form.parentElement.querySelector('[data-ceq-lead-form-error]')
      : null;

    if (submitBtn) submitBtn.disabled = true;
    if (label) label.hidden = true;
    if (loadingLabel) loadingLabel.hidden = false;
    if (errorBox) errorBox.hidden = true;

    var action = form.getAttribute('action') || '';
    var formData = new FormData(form);

    fetch(action, {
      method: 'POST',
      body: formData,
      mode: 'cors',
    })
      .then(function (resp) {
        if (!resp.ok) {
          throw new Error('HTTP ' + resp.status);
        }
        showSuccess(form);
        trackLeadEvent(form);
      })
      .catch(function (err) {
        console.error('[ceq-lead-form] submit failed', err);
        showError(form, errorBox);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
        if (label) label.hidden = false;
        if (loadingLabel) loadingLabel.hidden = true;
      });
  }

  function showSuccess(form) {
    form.hidden = true;
    var successBox = form.parentElement
      ? form.parentElement.querySelector('[data-ceq-lead-form-success]')
      : null;
    if (successBox) successBox.hidden = false;
  }

  function fakeSuccess(form) {
    showSuccess(form);
  }

  function showError(form, errorBox) {
    if (errorBox) errorBox.hidden = false;
  }

  function trackLeadEvent(form) {
    if (typeof window.dataLayer === 'undefined') return;
    window.dataLayer.push({
      event: 'generate_lead',
      form_id: form.id || form.getAttribute('data-section-id') || 'ceq-lead-form',
      page_path: window.location.pathname,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
